<template>
  <v-app app>
    <!-- App Bar -->
    <v-app-bar hide-on-scroll clipped-left dense dark fixed elevate-on-scroll style="background: black" app>
      <v-app-bar-nav-icon class="hidden-lg-and-up" style="color: white" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img class="mr-3" :src="require('./assets/LogoEvascopes.png')" height="50" />
      <v-btn class="overline ma-1" small @click="setLocale('en')"><flag iso="eu"/>en</v-btn>
      <v-btn class="overline" small @click="setLocale('es')"><flag iso="es"/>es</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-md-and-down pr-0">
        <v-btn href="#servicios" class="caption black white--text pa-1">{{$t(`barranavegacion[0]`)}}</v-btn>
        <v-btn href="#telescopios" class="caption black white--text pa-1">{{$t(`barranavegacion[1]`)}}</v-btn>
        <v-btn href="#localidad" class="caption black white--text pa-1">{{$t(`barranavegacion[2]`)}}</v-btn>
        <v-btn href="#galeria" class="caption black white--text pa-1">{{$t(`barranavegacion[3]`)}}</v-btn>
        <v-btn href="#precios" class="caption black white--text pa-1">{{$t(`barranavegacion[4]`)}}</v-btn>
        <v-btn href="#contacto" class="caption black white--text pa-1">{{$t(`barranavegacion[6]`)}}</v-btn>
        <v-btn href="#partners" class="caption black white--text pa-1">{{$t(`barranavegacion[7]`)}}</v-btn>
        <!-- <v-btn class="caption black white--text pa-1" flat v-for="n in 7" :key="n" v-text="$t(`barranavegacion[`+(n-1)+`]`)"></v-btn> -->
        <Login/>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary absolute width="200" id="drawer">
      <v-list nav>
        <v-list-item v-for="n in 7" :key="n" link>
          <v-list-item-content>
            <v-list-item-title v-text="$t(`barranavegacion[`+(n-1)+`]`)"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Fin App Bar -->
    <v-content>
      <Carrousel
        :titulouno="$t('tituloprincipal[0]')"
        :titulodos="$t('tituloprincipal[1]')"
        :titulotres="$t('tituloprincipal[2]')"
      />
      <Separador :textoSeparador="$t('separador[0]')" :icono="icono" :color="color" />
      <Servicios :titulo="$t('servicios')"/>
      <br />
      <Separador :textoSeparador="$t('separador[1]')" :icono="icono" :color="color" />
      <br />
      <div>
        <p
          class="display-1 text-center pt-1"
          style="color: #777777"
          v-text="$t('titulotelescopios[0]')"
        ></p>
        <p
          class="body-2 text-center pt-3"
          style="color: #777777"
          v-text="$t('titulotelescopios[1]')"
        ></p>
      </div>
      <br />
      <br />
      <Planwave id="telescopios"/>
      <Reginato />
      <br />
      <Separador :textoSeparador="$t('separador[2]')" :icono="icono" :color="color" />
      <br />
      <Location :localidad="$t('localidades')" id="localidad"/>
      <Separador :icono="icono" :color="color" :textoSeparador="'Gallery'" />
      <Gallery id="galeria"/>
      <Separador :textoSeparador="$t('separador[3]')" :icono="icono" :color="color" />
      <Precios id="precios"/>
      <br />
      <!-- <Separador :textoSeparador="$t('separador[4]')" :icono="icono" :color="color" />
      <br /> -->
      <!-- <MoonPhase /> -->
      <Separador :textoSeparador="$t('separador[5]')" :icono="icono" :color="color" />
      <Contacto :contacto="$t('contacto')" id="contacto" />
      <br />
      <Separador :textoSeparador="$t('separador[6]')" :icono="icono" :color="color" />

      <Partners id="partners"/>
      <About :info="$t('aboutus')" />
      <Pie />
    </v-content>
  </v-app>
</template>

<script>
import Carrousel from "./components/Carousel";
import Servicios from "./components/Servicios";
import Planwave from "./components/Planwave";
import Reginato from "./components/Reginato";
import Separador from "./components/Separadores/index";
import Location from "./components/Location";
import Gallery from "./components/Gallery";
import Precios from "./components/Precios";
import MoonPhase from "./components/MoonPhase";
import Contacto from "./components/Contacto";
import Partners from "./components/Partners";
import About from "./components/AboutUs";
import Pie from "./components/Pie";
import Login from "./components/Login";

export default {
  name: "App",
  components: {
    Carrousel,
    Servicios,
    Planwave,
    Reginato,
    Separador,
    Location,
    Gallery,
    Precios,
    MoonPhase,
    Contacto,
    Partners,
    About,
    Pie,
    Login
  },

  data() {
    return {
      collapseOnScroll: true,
      texto: [
        "OUR SERVICES",
        "OUR TELESCOPES",
        "LOCATION",
        "GALLERY",
        "PRICING",
        "MOONPHASE DISCOUNT",
        "CONTACT",
        "OUR PARTNERS"
      ],
      icono: "mdi-star",
      color: "color: #BDBDBD",
      dialog: false,
      dialogLogin: true,
      drawer: false
    };
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
    }
  }
};
</script>
